var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smsManage"},[_c('el-tabs',{attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"常规短信"}},[_c('sms-send')],1),_c('el-tab-pane',{attrs:{"label":"回访短信"}},[_c('sms-return-visit')],1),_c('el-tab-pane',{attrs:{"label":"短信模版"}},[_c('sms-template')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }